
import { defineComponent, onMounted, computed } from 'vue'
import { useStore } from '@/store/index'
import LayoutsAuth from '@/layouts/Auth.vue'
import VideoCategoryListContent from '@/components/VideoCategoryListContent.vue'
import { toArray } from '@/utils/array'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'

export default defineComponent({
  components: {
    LayoutsAuth, VideoCategoryListContent, LayoutsAuthWidth
  },
  setup() {
    const store = useStore()
    const videoCategories = computed(() => store.getters['video/formatVideoCategories']())

    onMounted(() => {
      Promise.allSettled([
        store.dispatch('video/fetchVideos'),
        store.dispatch('video/fetchVideoCategories')
      ])
    })

    return {
      store,
      toArray,
      videoCategories
    }
  },
})
